/** Render one cell value compactly. */
function cell(v: unknown): string {
  if (v == null) return "—";
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
}

/**
 * Render extracted data (an array of objects, or a single object/primitive) as a scannable
 * table — columns are the union of keys. Falls back to a single column for primitives.
 * Shared by the New-scraper AI preview and the "Latest data" panel.
 */
export function DataTable({ rows, limit = 25 }: { rows: unknown; limit?: number }) {
  const list = Array.isArray(rows) ? rows : rows == null ? [] : [rows];
  if (list.length === 0) return <div className="muted pad">No items.</div>;

  const cols = Array.from(
    new Set(list.flatMap((r) => (r && typeof r === "object" ? Object.keys(r as object) : []))),
  );

  return (
    <div className="preview-table-wrap">
      <table>
        {cols.length > 0 && (
          <thead>
            <tr>
              {cols.map((c) => (
                <th key={c}>{c}</th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {list.slice(0, limit).map((r, i) => (
            <tr key={i}>
              {cols.length > 0 ? (
                cols.map((c) => (
                  <td key={c} className="truncate">
                    {cell((r as Record<string, unknown>)?.[c])}
                  </td>
                ))
              ) : (
                <td className="truncate">{cell(r)}</td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      {list.length > limit && <div className="muted sm mt">+{list.length - limit} more rows</div>}
    </div>
  );
}
